export default __webpack_public_path__ + "static/media/Ies_panel_LilianaGonzalez.8ecdab0e.png";